export default {
  '--app-primary-color': '#830051',
  '--app-secondary-color': '#4d0030',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#4d0030',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#fbfbfbff',
  '--sidebar-active-text-color': '#830051'
};